import React from 'react';
import { Link } from 'react-router-dom';
import '../StylesComponents/design-system.css';

function NotFoundPage() {
  return (
    <div className="not-found-container" style={{ 
      height: '80vh', 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      color: 'var(--text-primary)',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div style={{ color: 'var(--accent-primary)', fontSize: '12px', marginBottom: '10px', fontFamily: 'var(--font-mono)' }}>
        Error Code: 404
      </div>
      <h1 style={{ fontSize: '6rem', fontWeight: '900', margin: '0', letterSpacing: '-5px' }}>PAGE NOT FOUND</h1>
      <p style={{ fontSize: '1.2rem', opacity: 0.7, maxWidth: '500px', marginBottom: '40px' }}>
        The page you are looking for doesn't exist or has been moved.
      </p>
      <Link to="/" className="brutalist-btn brutalist-btn-dark">
        Return to Home
      </Link>
    </div>
  );
}

export default NotFoundPage;
